//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio/Nicolas Pascucci
// Creation Date : 05/03/2024
// Version : 1
// Description : Pantalla de pedidos de NaturalGas
//------Changes ----------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/

import React, { useState, useEffect } from "react";
import moment from "moment";
import "moment/locale/es";
import {
  Button,
  Box,
  Stack,
  Snackbar,
  TextField,
  Alert,
  Grid,
  Autocomplete,
} from "@mui/material";
import Navbar from "../Navbar";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { UrlApi } from "../../services/apirest";
import Typography from "@mui/material/Typography";
import { Container } from "@mui/system";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import { logEventos } from "../../services/services";

const Item = styled(Paper)(({ theme }) => ({
  marginTop: theme.spacing(2),
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  textAlign: "center",
  border: "0px",
  [theme.breakpoints.down("sm")]: {
    width: "80%", // en mobile ocupa todo el ancho
  },
}));

const StyledStack = styled(Stack)(({ theme }) => ({
  borderRadius: "8px",
  margin: "20px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  gap: theme.spacing(2),
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column", // en mobile se apilan verticalmente
    alignItems: "center",
  },
}));

function PedidosNatural() {
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [disabledGuardar, setDisabledGuardar] = useState(false);
  const [originalSolicitudes, setOriginalSolicitudes] = useState([]);
  // FECHA NUEVA
  const fechaActual = moment();
  const [fechaInicioSemana, setFechaInicioSemana] = useState(
    fechaActual.clone().day(8)
  );
  const diasSemanaActual = [];
  //************************ OBTENER ****************************************************//
  const [bocaCargasSeleccionada, setBocaCargasSeleccionada] = useState("");

  const [solicitudes, setSolicitudes] = useState();
  const obtenerSolicitudes = () => {
    fetch(
      UrlApi +
        "/proveedores_abastecimiento/existentesNatural/" +
        bocaCargasSeleccionada.idbocas_carga +
        "/'" +
        diasSemanaActual[0].fecha +
        "'/'" +
        diasSemanaActual[6].fecha +
        "'"
    )
      .then((data) => data.json())
      .then((data) => setSolicitudes(data));
  };
  useEffect(() => {
    obtenerSolicitudes();
  }, [bocaCargasSeleccionada, fechaInicioSemana]);

  // console.log("SOLICITUDES EXISTENTES", solicitudes);
  useEffect(() => {
    if (solicitudes) {
      setOriginalSolicitudes(solicitudes);
    }
  }, [solicitudes]);
  //************************ OBTENER ****************************************************//

  const [bocasCargas, setBocasCargas] = useState([]);

  const obtenerBocas = () => {
    fetch(UrlApi + "/bocas_carga/")
      .then((data) => data.json())
      .then((data) => setBocasCargas(data));
  };
  useEffect(() => {
    obtenerBocas();
  }, []);
  // console.log("BOCAS DE CARGAS", bocasCargas);

  // console.log("BOCA DE CARGA SELECCIONADA", bocaCargasSeleccionada);

  // console.log("PROVEEDOR SELECCIONADO", bocaCargasSeleccionada.idbocas_carga);

  //************************ FECHA ****************************************************//

  // Obtén la fecha actual o la fecha deseada

  //  console.log(fechaActual.format("dddd"));

  // Calcula la fecha del próximo lunes
  const lunesProximo = fechaActual.clone().day(8); // 8 representa el día lunes de la próxima semana

  // Obtén los nombres y fechas de los días de la semana para la próxima semana
  const diasProximaSemana = [];
  for (let i = 0; i < 7; i++) {
    const fechaDia = lunesProximo.clone().add(i, "days");
    diasProximaSemana.push({
      id: i, // Utilizamos la posición en el bucle como id
      nombre: fechaDia.format("dddd"),
      fecha: fechaDia.format("YYYY-MM-DD"),
    });
  }
  // console.log(" DIAS ", diasProximaSemana);
  //******************************** VALORES ******************************************** //
  const [butanoValues, setButanoValues] = useState(
    Array(diasSemanaActual.length).fill("")
  );
  const [propanoValues, setPropanoValues] = useState(
    Array(diasSemanaActual.length).fill("")
  );

  useEffect(() => {
    // Obtener los valores de propano y butano de las solicitudes y actualizar el estado
    if (solicitudes) {
      const butanoData = Array(diasSemanaActual.length).fill("");
      const propanoData = Array(diasSemanaActual.length).fill("");

      solicitudes.forEach((solicitud) => {
        const index = diasSemanaActual.findIndex((item) =>
          moment(item.fecha).isSame(solicitud.fecha, "day")
        );

        if (index !== -1) {
          if (solicitud.butano !== null) {
            butanoData[index] = {
              fecha: solicitud.fecha,
              value: solicitud.butano,
            };
          }

          if (solicitud.propano !== null) {
            propanoData[index] = {
              fecha: solicitud.fecha,
              value: solicitud.propano,
            };
          }
        }
      });
      setButanoValues(butanoData);
      setPropanoValues(propanoData);
    }
  }, [solicitudes]);

  const handleButanoChange = (index, value, fecha) => {
    const newValues = [...butanoValues];
    newValues[index] = { fecha, value };
    setButanoValues(newValues);
  };

  const handlePropanoChange = (index, value, fecha) => {
    const newValues = [...propanoValues];
    newValues[index] = { fecha, value };
    setPropanoValues(newValues);
  };

  const guardarSolicitudes = async () => {
    logEventos(
      "Guardar solicitud",
      "Pedidos a Petroleras",
      "Se guardo la solicitud",
      localStorage.getItem("user")
    );
    setDisabledGuardar(true);
    try {
      let cambiosRealizados = false;

      for (let index = 0; index < diasSemanaActual.length; index++) {
        const item = diasSemanaActual[index];
        const solicitudExistente = solicitudes.find(
          (solicitud) =>
            moment(solicitud.fecha).isSame(item.fecha, "day") &&
            solicitud.proveedor ===
              parseInt(bocaCargasSeleccionada.idbocas_carga)
        );

        if (solicitudExistente) {
          // Lógica para PUT (actualización)
          const originalSolicitud = originalSolicitudes.find(
            (solicitud) =>
              moment(solicitud.fecha).isSame(item.fecha, "day") &&
              solicitud.proveedor ===
                parseInt(bocaCargasSeleccionada.idbocas_carga)
          );

          const updatedFields = {};

          // Comparar butano
          if (
            Number(butanoValues[index].value) !==
            Number(originalSolicitud.butano)
          ) {
            updatedFields.butano = Number(butanoValues[index].value);
            updatedFields.viaje_butano = Number(butanoValues[index].value);
          }

          // Comparar propano
          if (
            Number(propanoValues[index].value) !==
            Number(originalSolicitud.propano)
          ) {
            updatedFields.propano = Number(propanoValues[index].value);
            updatedFields.viaje_propano = Number(propanoValues[index].value);
          }

          // Si hay campos actualizados, hacer PUT
          if (Object.keys(updatedFields).length > 0) {
            const response = await fetch(
              UrlApi + "/proveedores_abastecimiento/" + solicitudExistente.id,
              {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  ...updatedFields,
                  usuario: localStorage.getItem("user"),
                }),
              }
            );

            const responseData = await response.json();

            if (!responseData.err) {
              // console.log("Guardado (PUT) para el día:", item.fecha);
              cambiosRealizados = true;
            } else {
              console.log("Error al guardar (PUT) para el día:", item.fecha);
            }
          } else {
            // console.log("No hay cambios para el día:", item.fecha);
          }
        } else {
          // Lógica para POST (creación)
          const response = await fetch(UrlApi + "/proveedores_abastecimiento", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              fecha: butanoValues[index].fecha
                ? moment(butanoValues[index].fecha).format("YYYY-MM-DD")
                : diasSemanaActual[index].fecha,
              butano: butanoValues[index].value,
              propano: propanoValues[index].value,
              viaje_butano: butanoValues[index].value,
              viaje_propano: propanoValues[index].value,
              usuario: localStorage.getItem("user"),
              proveedor: bocaCargasSeleccionada.idbocas_carga,
              empresa_destino: 4,
            }),
          });

          const responseData = await response.json();

          if (!responseData.err) {
            // console.log("Guardado (POST) para el día:", item.fecha);
            cambiosRealizados = true;
          } else {
            console.log("Error al guardar (POST) para el día:", item.fecha);
          }
        }
      }

      if (cambiosRealizados) {
        setOpenSnack(true);
        setColorMensaje("#D4EFDF");
        setMensaje("Los pedidos se guardaron exitosamente !");
      } else {
        // console.log("No hay cambios para guardar");
      }
    } catch (error) {
      console.error("Error:", error.message);
    }
    obtenerSolicitudes();
  };

  //******************************** TABLAS ******************************************** //

  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    setDisabledGuardar(false);
  };
  // Imprime los nombres y fechas de los días de la próxima semana
  // console.log("VALOR DE PROPANO Y BUTANO:", butanoValues, propanoValues);

  useEffect(() => {
    if (bocaCargasSeleccionada.length === 0) {
      setDisabledGuardar(true);
    } else {
      setDisabledGuardar(false);
    }
  }, [bocaCargasSeleccionada]);
  //*****************************FECHAS****************************************/

  const irSemanaAnterior = () => {
    setFechaInicioSemana((prevFecha) => prevFecha.clone().subtract(7, "days"));
    // setCambio(true)
    // obtenerSolicitudes()
  };

  const irSemanaSiguiente = () => {
    setFechaInicioSemana((prevFecha) => prevFecha.clone().add(7, "days"));
    // obtenerSolicitudes()
    // setCambio(true)
  };

  for (let i = 0; i < 7; i++) {
    const fechaDia = fechaInicioSemana.clone().add(i, "days");
    diasSemanaActual.push({
      id: i,
      nombre: fechaDia.format("dddd"),
      fecha: fechaDia.format("YYYY-MM-DD"),
    });
  }

  return (
    <>
      {/* <Navbar /> */}
      <Box
        bgcolor="#2B76A6"
        padding={1}
        borderRadius={0}
        color="white"
        textAlign="center"
        display="flex" // Agregado para que los elementos se coloquen en línea
        alignItems="center"
        marginTop={1}
        flexDirection={{ xs: "column", sm: "row" }}
      >
        <LocalFireDepartmentIcon
          sx={{
            fontSize: { xs: 30, sm: 40 }, // ícono más chico en mobile
            mr: { sm: 2 }, // margen derecho solo en desktop
            mb: { xs: 1, sm: 0 }, // margen abajo solo en mobile
          }}
        />
        <Typography
          variant="h4"
          component="div"
          sx={{ fontSize: { xs: "1.5rem", sm: "2rem" } }}
        >
          NaturalGas
        </Typography>
      </Box>
      <form>
        <Container style={{ marginTop: 12, marginLeft: -2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Autocomplete
                disabled={!bocasCargas}
                disableClearable
                size="small"
                //  focused
                required
                id="idbocas_carga"
                noOptionsText={"Proveedor INEXISTENTE"}
                options={bocasCargas || []}
                autoHighlight
                getOptionLabel={(bocasCargas) =>
                  bocasCargas.idbocas_carga +
                  "-" +
                  bocasCargas.proveedor +
                  "-" +
                  bocasCargas.nombre_boca
                }
                onChange={(event, value) => setBocaCargasSeleccionada(value)}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    key={option.id}
                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                    {...props}
                  >
                    {option.idbocas_carga} - {option.proveedor} -{" "}
                    {option.nombre_boca}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    inputProps={{
                      ...params.inputProps,
                    }}
                    //  focused
                    style={style}
                    size="small"
                    placeholder="Tipee para buscar..."
                    label="Proveedor"
                  />
                )}
              />
            </Grid>
          </Grid>
        </Container>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1}
          justifyContent="center"
          alignItems="center"
          sx={{ marginTop: 1 }}
        >
          <Button onClick={irSemanaAnterior} variant="contained" size="small">
            &lt; Semana Anterior
          </Button>
          <Button
            onClick={irSemanaSiguiente}
            variant="contained"
            sx={{ marginLeft: 1 }}
            size="small"
          >
            Semana Siguiente &gt;
          </Button>
        </Stack>

        <StyledStack direction="row" spacing={2}>
          {diasSemanaActual.map((item, index) => (
            <Item
              key={index}
              sx={{
                fontSize: 20,
                color: "white",
                backgroundColor: "#2B76A6",
              }}
            >
              <Box backgroundColor="#2B76A6">
                <div style={{ margin: "1px 0" }}></div>
                {`${item.nombre.toUpperCase()}`} <br />{" "}
                {`${moment(item.fecha).format("DD-MM-YYYY")}`}
                <div style={{ margin: "4px 0" }}></div>
              </Box>
              <Box backgroundColor="#F4F6F6" p={2} borderRadius={2}>
                <TextField
                  style={{ backgroundColor: "white" }}
                  sx={{ mt: 2 }}
                  id={`butano-${index}`}
                  label="Butano"
                  variant="outlined"
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  //  focused
                  required
                  value={butanoValues[index] ? butanoValues[index].value : ""}
                  onChange={(e) =>
                    handleButanoChange(index, e.target.value, item.fecha)
                  }
                />
                <TextField
                  style={{ backgroundColor: "white" }}
                  sx={{ mt: 2 }}
                  id={`propano-${index}`}
                  label="Propano"
                  variant="outlined"
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  //  focused
                  required
                  value={propanoValues[index] ? propanoValues[index].value : ""}
                  onChange={(e) =>
                    handlePropanoChange(index, e.target.value, item.fecha)
                  }
                />
              </Box>
            </Item>
          ))}
        </StyledStack>

        <Grid
          container
          justifyContent={{ xs: "center", sm: "flex-end" }}
          mt={{ xs: 1, sm: 1 }}
          pr={{ sm: 5 }}
        >
          <Grid item>
            <Button
              variant="contained"
              disabled={disabledGuardar}
              onClick={guardarSolicitudes}
              size="large"
              sx={{
                width: { xs: "100%", sm: "auto" }, // ocupa todo el ancho en mobile
                maxWidth: { xs: 300, sm: "none" }, // opcional: limita el ancho en mobile
              }}
            >
              Guardar
            </Button>
          </Grid>
        </Grid>
      </form>
      <br />
      <br />
      <br />

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default PedidosNatural;
